export const TEMP_CUSTOMER_MANAGERS = [
  {
    key: '1',
    value: 'Manager 1'
  },
  {
    key: '2',
    value: 'Manager 2'
  },
];

export const CUSTOMER_TYPE_ICONS = {
  individual: 'user',
  company: 'company',
  sole_trader: 'sole_trader',
};

export const CONTACT_SUBTYPES = [
  {
    key: 'home',
    value: 'customer.contact.phone.home'
  },
  {
    key: 'office',
    value: 'customer.contact.phone.office'
  },
  {
    key: 'mobile',
    value: 'customer.contact.phone.mobile'
  },
];

//@TODO: refactor validation fields to by dynamic from schema. Example participant address/additional fields
export const ADDRESS_VALIDATION_FIELDS = [
  'type',
  'street',
  'house',
  'zip_code',
  'city',
  'region',
  'country'
];

export const PARTICIPANT_VALIDATION_FIELDS = [
  'name',
  'regon',
  'nip',
  'companyType',
  'companyForm',
  'firstName',
  'lastName',
  'pesel',
  'birthDate',
  'gender',
  'countryCode'
];

export const POLICY_HOLDER_VALIDATION_FIELDS = [
  'first_name',
  'last_name',
  'birthday',
  'sex'
];

export const SOLE_TRADER_POLICY_HOLDER_VALIDATION_FIELDS = [
  'pesel',
  'first_name',
  'last_name'
];

export const SOLE_TRADER_PARTICIPANT_VALIDATION_FIELDS = [
  'pesel',
  'firstName',
  'lastName'
];

export const SOLE_TRADER_POLICY_HOLDER_ADDITIONAL_VALIDATION_FIELDS = [
  'birthday',
  'sex',
];

export const SOLE_TRADER_PARTICIPANT_ADDITIONAL_VALIDATION_FIELDS = [
  'birthDate',
  'gender',
];

export const PARTICIPANT_INSURER_REQUIRED_FIELDS = [
  'maritalStatus',
  'occupationId',
  'childrenCount',
];

export const DRIVER_PARTICIPANT_INSURER_REQUIRED_FIELD = 'drivingLicenseIssueDate';

export const BORDER_PARTICIPANT_INSURER_REQUIRED_FIELDS: string[] = [];

export const CUSTOMER_CONTACT_VALIDATION_FIELDS = [
  'type',
  'value',
  'subtype'
];

export const CUSTOMER_VALIDATION_FIELDS = [
  'regon',
  'nip',
  'pesel',
  'idCode',
  'company_name',
  'company_type',
  'first_name',
  'last_name',
  'birthday',
  'sex',
  'countryCode'
];

export const CUSTOMER_COMMON_VALIDATION_FIELDS = [
  'contacts',
  'addresses'
];

export const VEHICLE_DB_SOURCE = {
  infoexpert: 'infoexpert',
  eurotax: 'eurotax'
};

export const motorProducts = [
  'motor-mtpl',
  'motor-accident',
  'motor-assistance',
  'motor-casco',
  'motor-glass',
  'motor-luggage',
  'motor-discounts',
];

export const externalInsurerLinks: Record<string, string> = {
  'mtu': 'https://sso.ergohestia.pl/my.policy',
  'ycd': 'https://sso.ergohestia.pl/my.policy',
  'pzu': 'https://everest.pzu.pl/my.policy',
  'warta': 'https://cas.warta.pl/cas/login?service=https://eagent.warta.pl/view360/login/cas',
  'hdi': 'https://cas.warta.pl/cas/login?service=https://eagent.warta.pl/view360/login/cas',
  'uniqa': 'https://portal.uniqa.pl/anonymous/login',
  'pevno': 'https://portal.uniqa.pl/anonymous/login',
};

export const externalInsurerLinksDynamic: string[] = [
  'link4',
  'proama',
  'generali',
  'tuz',
  'interrisk',
  'wefox',
  'tuw',
  'compensa',
  'agro',
  'dallbogg',
  'trasti',
  'bianca',
];

export const hidePolicyLinkInsurerList: string[] = [
  'agro'
];

export const CONTACT_PERSON_VALIDATION_FIELDS: string[] = ['phone', 'email', 'first_name', 'last_name'];
